"use strict";
const DAY=86400000;
const PLANETS=Object.freeze([
 ['Sun','Sol','Sun','☉'],['Moon','Luna','Moon','☽'],['Mercury','Mercurio','Mercury','☿'],['Venus','Venus','Venus','♀'],['Mars','Marte','Mars','♂'],
 ['Jupiter','Júpiter','Jupiter','♃'],['Saturn','Saturno','Saturn','♄'],['Uranus','Urano','Uranus','♅'],['Neptune','Neptuno','Neptune','♆'],['Pluto','Plutón','Pluto','♇']
].map(([key,label,en,glyph])=>Object.freeze({key,label,en,glyph})));
const ASPECTS=Object.freeze([
 [0,'Conjunción','Conjunction','☌','#d9b479'],[60,'Sextil','Sextile','⚹','#78b5d2'],[90,'Cuadratura','Square','□','#df8e8c'],
 [120,'Trígono','Trine','△','#80baa4'],[150,'Quincuncio','Quincunx','⚻','#afa1ce'],[180,'Oposición','Opposition','☍','#d894b2']
].map(([angle,label,en,glyph,color])=>Object.freeze({angle,label,en,glyph,color})));
const norm=n=>((n%360)+360)%360;
const delta=(a,b)=>norm(b-a+180)-180;
const distance=(a,b)=>Math.abs(delta(a,b));
function segment(a,b){
 const days=(b.time-a.time)/DAY,p0=a.unwrapped??a.longitude,p1=p0+delta(a.longitude,b.longitude),m0=a.speed*days,m1=b.speed*days;
 return {start:a.time,end:b.time,a:2*p0-2*p1+m0+m1,b:-3*p0+3*p1-2*m0-m1,c:m0,d:p0};
}
const value=(s,u)=>((s.a*u+s.b)*u+s.c)*u+s.d;
const speed=(s,u)=>(3*s.a*u*u+2*s.b*u+s.c)*DAY/(s.end-s.start);
function segments(samples){let unwrapped=samples[0]?.longitude||0;return samples.slice(0,-1).map((a,i)=>{const s=segment({...a,unwrapped},samples[i+1]);unwrapped=value(s,1);return s;});}
function at(samples,time){
 if(!samples?.length)return null;
 if(time<=samples[0].time)return {...samples[0]};if(time>=samples.at(-1).time)return {...samples.at(-1)};
 let lo=0,hi=samples.length-1;while(hi-lo>1){const mid=(lo+hi)>>1;if(samples[mid].time<=time)lo=mid;else hi=mid;}
 const s=segment(samples[lo],samples[hi]),u=(time-s.start)/(s.end-s.start);
 return {time,longitude:norm(value(s,u)),speed:speed(s,u)};
}
function extrema(s){
 const points=[0,1],a=3*s.a,b=2*s.b,c=s.c;
 if(Math.abs(a)<1e-12){if(Math.abs(b)>1e-12)points.push(-c/b);}
 else{const discriminant=b*b-4*a*c;if(discriminant>=0){points.push((-b-Math.sqrt(discriminant))/(2*a),(-b+Math.sqrt(discriminant))/(2*a));}}
 return [...new Set(points.filter(u=>u>=0&&u<=1))].sort((a,b)=>a-b);
}
function roots(s,target){
 const found=[],stops=extrema(s);
 for(let i=1;i<stops.length;i++){
  let lo=stops[i-1],hi=stops[i],a=value(s,lo)-target,b=value(s,hi)-target;
  if(Math.abs(a)<1e-9)found.push(lo);if(Math.abs(b)<1e-9)found.push(hi);
  if(a*b>=0)continue;
  for(let j=0;j<45;j++){const mid=(lo+hi)/2,m=value(s,mid)-target;if(a*m<=0){hi=mid;b=m;}else{lo=mid;a=m;}}
  found.push((lo+hi)/2);
 }
 return found;
}
module.exports={DAY,PLANETS,ASPECTS,norm,delta,distance,segment,segments,value,speed,at,extrema,roots};
